import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Instagram, Mail, Facebook, MapPin, MessageCircle } from 'lucide-react';
import logo from '../assets/logo.png';

const Footer = () => {
    return (
        <footer className="bg-primary text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

                    {/* Brand & Tagline */}
                    <div className="space-y-4">
                        <img src={logo} alt="Thread and Needle Valley" className="h-24 w-auto brightness-200 grayscale contrast-200" style={{ filter: 'brightness(0) invert(1)' }} />
                        <p className="text-green-50 text-sm mt-4">
                            Premium Custom Manufacturing for Bedsheets, Towels, and Apparel.
                        </p>
                        <p className="text-lg font-serif italic text-white opacity-90">
                            "We Bring Your Ideas To Life"
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 text-white">Quick Links</h3>
                        <ul className="space-y-3">
                            <li><Link to="/" className="text-green-50 hover:text-white transition">Home</Link></li>
                            <li><Link to="/about" className="text-green-50 hover:text-white transition">About Us</Link></li>
                            <li><Link to="/collection" className="text-green-50 hover:text-white transition">Our Collection</Link></li>
                            <li><Link to="/catlog.pdf" target="_blank" className="text-green-50 hover:text-white transition">Download Catalog</Link></li>
                            <li><Link to="/contact" className="text-green-50 hover:text-white transition">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 text-white">Contact Us</h3>
                        <ul className="space-y-4 text-green-50">
                            <li className="flex items-start gap-3">
                                <MapPin className="mt-1 flex-shrink-0 text-green-200" size={20} />
                                <span>Plot A/6 Sector 11-G New Karachi, Pakistan</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="flex-shrink-0 text-green-200" size={20} />
                                <span>+923318689110 | +923155514161</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="flex-shrink-0 text-green-200" size={20} />
                                <span>info@threadneedlevalley.com</span>
                            </li>
                        </ul>

                        {/* Social Icons */}
                        <div className="flex space-x-4 mt-6">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-[#1a7157] p-2 rounded-full hover:bg-white hover:text-primary transition inline-flex"><Facebook size={20} /></a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-[#1a7157] p-2 rounded-full hover:bg-white hover:text-primary transition inline-flex"><Instagram size={20} /></a>
                            <a href="https://wa.me/923318689110" target="_blank" rel="noopener noreferrer" className="bg-[#1a7157] p-2 rounded-full hover:bg-white hover:text-primary transition inline-flex"><MessageCircle size={20} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t border-[#1a7157] mt-12 pt-8 text-center text-green-100 text-sm">
                &copy; {new Date().getFullYear()} Thread and Needle Valley. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
